module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.slides), function(slide) {
    return _c('div', {
      staticClass: "swiper-slide",
      class: {
        'swiper-no-swiping': _vm.slides.length == 1
      },
      style: ({
        backgroundImage: 'url(' + slide + ')'
      })
    })
  })), _vm._v(" "), (_vm.slides.length > 1) ? _c('div', {
    staticClass: "swiper-pagination"
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-577b7a5f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-577b7a5f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/composite/swiper/src/swiper.vue
// module id = 1070
// module chunks = 1